(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rww-v2-productos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rwwV2Qv) return;
    window.__rwwV2Qv = true;

    function closeDialog(dlg) {
      if (dlg && dlg.open) dlg.close();
    }

    document.addEventListener('click', function (e) {
      // Manejador del Slider (Flechas)
      var prevBtn = e.target.closest('[data-rww-qv-prev]');
      var nextBtn = e.target.closest('[data-rww-qv-next]');

      if (prevBtn || nextBtn) {
        var wrap = (prevBtn || nextBtn).closest('.rww-v2p__qv-media-wrap');
        var slider = wrap.querySelector('[data-rww-qv-slider]');
        if (slider) {
          var scrollAmount = slider.clientWidth;
          if (prevBtn) {
            slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          } else {
            slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }
        }
        return;
      }

      // Abrir Modal
      var opener = e.target.closest('[data-rww-qv-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('data-rww-qv-open'));
        if (dlg && typeof dlg.showModal === 'function') {
          dlg.showModal();
          document.documentElement.classList.add('rww-qv-lock');
          dlg.addEventListener(
            'close',
            function () { document.documentElement.classList.remove('rww-qv-lock'); },
            { once: true }
          );
        }
        return;
      }

      // Cerrar Modal (Botón de X)
      var closer = e.target.closest('[data-rww-qv-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      // Cerrar Modal (Clic fuera)
      if (e.target.matches('dialog.rww-v2p__qv[open]')) {
        closeDialog(e.target);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-rww-qv-variant]');
      if (!input) return;
      var dlg = input.closest('dialog');
      if (!dlg) return;

      var priceEl = dlg.querySelector('[data-rww-qv-price]');
      if (priceEl && input.getAttribute('data-price')) {
        priceEl.textContent = input.getAttribute('data-price');
      }
      
      var isAvailable = input.getAttribute('data-available') === 'true';
      var atc = dlg.querySelector('[data-rww-qv-atc]');
      
      if (atc) {
        atc.setAttribute('data-variant-id', input.value);
        atc.disabled = !isAvailable;
        atc.textContent = isAvailable ? (atc.getAttribute('data-lbl-atc') || 'Agregar al carrito') : 'Agotado';
      }

      var buy = dlg.querySelector('[data-rww-qv-buy]');
      if (buy) {
        var base = buy.getAttribute('data-cart-base') || '/cart';
        buy.setAttribute('href', base + '/' + input.value + ':1');
        buy.style.display = isAvailable ? 'inline-flex' : 'none';
      }
    });

    // Agregar al carrito (Forzando la petición manual para activar UpCart)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rww-qv-atc]');
      if (!btn || btn.disabled) return;
      var dlg = btn.closest('dialog');

      e.preventDefault();
      btn.classList.add('is--loading');
      
      var formData = {
        'items': [{
          'id': Number(btn.getAttribute('data-variant-id')),
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function() {
        btn.classList.remove('is--loading');
        closeDialog(dlg);
        window.dispatchEvent(new Event('cart:build'));
      })
      .catch(function(error) {
        console.error('Error al agregar al carrito:', error);
        btn.classList.remove('is--loading');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
